import React from "react"
import _ from "lodash"
import styled, { css } from "styled-components"
import Color from "color"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import "./Image.scss"

const LUM_THRESHOLD = 0.6
const ROUTER_BASE = process.env.REACT_APP_ROUTER_BASE || ""

const PopupIcon = styled.div`
  width: 14px;
  height: 14px;
  background: url('${ROUTER_BASE}/popup_dark.png') center no-repeat;
  background-size: contain;
`

const ImageBubblePlaceholder = styled.div`
  border-radius: 8px;
  width: 100px;
  padding: 16px;
  min-height: 100px;
  background-color: ${props => props.isUser ? (props.color || "#0084FF") : "#F1F0F0"};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.11);

  .icon {
    font-size: 50px;
    color: ${(props) => {
      if (props.isUser) {
        const bg = Color(props.color)
        if (bg.luminosity() > LUM_THRESHOLD) {
          return "#555"
        }
      }
      return "#ffffff"
    }};
    margin-bottom: 8px;
  }

  span {
    font-size: 0.7rem;
    text-align: center;
    color: #555;
  }
  .caption {
    background: #f1f0f0;
    padding: 8px 10px;
    word-break: break-word;
    width: calc(100% - 20px);
    line-height: 1.2rem;
    color: #626262;
    white-space: pre-wrap;
  }
`
const ImageBubble = styled.div`
  position: relative;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.11);
  border-radius: 8px;
  img {
    border-radius: 8px;
    overflow: hideen;
    width: 100%;
    vertical-align: bottom;

    ${props => props.hasCaption && css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
  }
  .caption {
    background: #f1f0f0;
    padding: 8px 10px;
    word-break: break-word;
    width: calc(100% - 20px);
    line-height: 1.2rem;
    color: #626262;
    white-space: pre-wrap;
  }
`

const ImageLinkOutWrapper = styled.a`
  position: absolute;
  top: 0;
  right: -100px;
  width: 100px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: auto;
  opacity: ${props => props.show ? "1" : "0"};
  pointer-event: ${props => props.show ? "all" : "none"};
  transition: all 0.2s linear;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-tap-highlight-color: transparent;

  .button {
    background: #F1F0F0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    cursor: pointer;
    color: #888;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: transparent;
  }
`

class Image extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hover: false
    }
  }

  render() {
    const { data, isUser, color } = this.props
    const url = data.url || data.downloadUrl || _.get(data, "attachments[0].url")
    if (url) {
      return (
        <ImageBubble
          hasCaption={!!(data.text || data.caption)}
          onFocus={() => {
            this.setState({
              hover: true
            })
          }}
          onBlur={() => {
            this.setState({
              hover: false
            })
          }}
          onMouseOver={() => {
            this.setState({
              hover: true
            })
          }}
          onMouseLeave={() => {
            this.setState({
              hover: false
            })
          }}
          onClick={() => {
            this.setState({
              hover: !this.state.hover
            })
          }}
        >
          <img src={url ? url : ""} alt="" />
          <ImageLinkOutWrapper
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            show={this.state.hover}
          >
            <div className="button">
              <PopupIcon
                color={color}
                className="icon"
              />
            </div>
          </ImageLinkOutWrapper>
          {
            data.text || data.caption ?
              <div className="caption">{data.text || data.caption}</div>
              :
              null
          }
        </ImageBubble>
      )
    }
    return (
      <ImageBubblePlaceholder
        isUser={isUser}
        color={color}
      >
        <FontAwesomeIcon
          className="icon"
          icon="image"
        />
        <span>Image cannot be loaded</span>
        {
          data.text || data.caption ?
            <div className="caption">{data.text || data.caption}</div>
            :
            null
        }
      </ImageBubblePlaceholder>
    )
  }
}

export default Image
